import { useFormContext } from "react-hook-form";
import { FormValues } from "src/hooks/form";

// お客様情報入力画面のロジックを管理するカスタムフック
export const useInputPersonalPage = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormValues>();

  return {
    control,
    errors,
  };
};
